export default __webpack_public_path__ + "static/media/jumping3.d80a013a.jpg";